import classNames from 'classnames';
import React, { FC } from 'react';

import useStyles from '../styles';

export const HeaderIcon: FC = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.headerIcon}>{children}</div>;
};

export interface DrawerHeaderProps {
  className?: string;
  grayBackground?: boolean;
  showShadow?: boolean;
}

export const DrawerHeader: FC<DrawerHeaderProps> = ({
  children,
  className,
  grayBackground = false,
  showShadow = false,
}) => {
  const classes = useStyles({ grayBackground, showShadow });

  return <div className={classNames(classes.drawerHeader, className)}>{children}</div>;
};
